import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-end bg-white",
  tabindex: "-1",
  id: "settingsSidebar",
  "aria-labelledby": "settingsSidebarLabel",
  style: {"box-shadow":"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
}
const _hoisted_2 = { class: "offcanvas-body p-4" }
const _hoisted_3 = { class: "mb-4 pb-2" }
const _hoisted_4 = { class: "mb-4 pb-2" }
const _hoisted_5 = { class: "mb-4 pb-2" }
const _hoisted_6 = { class: "mb-4 pb-2" }
const _hoisted_7 = { class: "mb-4 pb-2" }
const _hoisted_8 = { class: "mb-4 pb-2" }
const _hoisted_9 = { class: "mb-4 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RTLModeSwitch = _resolveComponent("RTLModeSwitch")!
  const _component_HorizontalLayout = _resolveComponent("HorizontalLayout")!
  const _component_OnlySidebarDark = _resolveComponent("OnlySidebarDark")!
  const _component_OnlyHeaderDark = _resolveComponent("OnlyHeaderDark")!
  const _component_OnlyFooterDark = _resolveComponent("OnlyFooterDark")!
  const _component_CardStyleRadius = _resolveComponent("CardStyleRadius")!
  const _component_CardStyleBG = _resolveComponent("CardStyleBG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "offcanvas-header bg-body-bg py-3 px-4" }, [
      _createElementVNode("h5", {
        class: "offcanvas-title fs-18",
        id: "settingsSidebarLabel"
      }, " Theme Settings "),
      _createElementVNode("button", {
        type: "button",
        class: "btn-close",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, "RTL / LTR", -1)),
        _createVNode(_component_RTLModeSwitch)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Horizontal Layout ", -1)),
        _createVNode(_component_HorizontalLayout)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Only Sidebar Light / Dark ", -1)),
        _createVNode(_component_OnlySidebarDark)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Only Header Light / Dark ", -1)),
        _createVNode(_component_OnlyHeaderDark)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Only Footer Light / Dark ", -1)),
        _createVNode(_component_OnlyFooterDark)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Card Style Radius / Square ", -1)),
        _createVNode(_component_CardStyleRadius)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "fs-15 fw-semibold border-bottom pb-2 mb-3" }, " Card Style BG White / Gray ", -1)),
        _createVNode(_component_CardStyleBG)
      ])
    ])
  ]))
}